import store from '../store'
import axios from 'axios'

const api = (req, data = {}) => {
  data.req = req
  return new Promise((resolve, reject) => {
    axios.post(store.getters.server, data)
      .then(resp => {
        if (resp.data.msg !== 'success') {
          reject(resp.data.msg || 'unknown')
        } else {
          resolve(resp.data)
        }
      })
      .catch(err => {
        reject(err.toString())
      })
  })
}

export default api
